import type { Question } from '@mentimeter/legacy-series-types/question';
import type { CompatibilitySlide } from '../../compatibility-types';

export const getQuestionQuizChoicesProperty = (
  target: CompatibilitySlide<'quiz-choice'>,
  prop: keyof Question,
) => {
  const staticContent = target.staticContent;

  if (prop === 'question_styled') {
    return staticContent.styledTitle ?? {};
  }

  return undefined;
};
